import API from "api/axiosInstance";
import { setIsLoading, setListJabatan, setStatus } from "./index";

export const fetchListJabatan = () => async (dispatch) => {
  dispatch(setIsLoading(true));
  try {
    const response = await API.get("/jabatan");
    dispatch(setIsLoading(false));
    dispatch(setListJabatan(response.data.data));
  } catch (error) {
    dispatch(setIsLoading(false));
    dispatch(setStatus("failed"));
  }
};
